import React, { Component } from "react";
import {
  DKDataGrid,
  shiftArrayElement,
  INPUT_TYPE,
  DKIcons,
  showAlert,
  showToast,
  TOAST_TYPE,
  DKLabel,
  showLoader,
  removeLoader,
  isEmpty,
  DKIcon,
  DKTooltipWrapper,
  DKButton
} from "deskera-ui-library";
import Table from "../../services/table";
import TableDataParser from "../../Helper/TableDataParser";
import {
  TableManger,
  TABLE_DISPLAY_NAME,
  TABLES,
  COLUMN_CODE,
} from "../../managers/TableManger";
import { AddRecordButtonConfig, IColumn } from "../../model/Table";
import ContextMenu from "../common/ContextMenu";
import { commonCustomEvent, COMMON_EVENTS } from "../../services/event/commonEvents";
import JobPipelineService from "./Dashboard/JobPipeline";
import { CANDIDATE_ACCEPT_FILE_TYPE, CONSTANTS, FILE_EXTENSION_GROUP, FILE_TYPE, VALID_FIELD_MAX_LENGTH } from "../../constants/Constant";
import SideBarService from "../../services/sidebar";
import Utility, { deepClone } from "../../utility/Utility";
import ic_visibility from '../../assets/icons/white/ic_visibility.png'
import ic_add from '../../assets/icons/ic_add.png'
import {isViewportLarge} from "../../utility/ViewportSizeUtils";
import ic_no_data from "../../assets/icons/ic_no_data_3.png";
import ApiManager from "../../managers/ApiManager";
import i18next from "i18next";
import AutomationManager from "../automation/AutomationManager";
import { renderFileHtml, stringSanitizer } from "../../managers/common/CommonUtil";
import debounce from "../../utility/Debounce";
import ContactManager from "../../managers/ContactManager";
import ColumnVisibility from "../ColumnVisibility";
import { getDashboardOrder } from "../../Redux/Slices/userPrefSlice";
import { connect, ConnectedProps } from "react-redux"; 
import { isEqual } from "lodash"; 
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
export interface IDataGridHolderProps extends PropsFromRedux {
  tableName: string;
  displayTableName?: string;
  filter?: any;
  allowRowEdit?: boolean;
  allowColumnEdit?: boolean;
  allowRowAdd?: boolean;
  allowColumnAdd?: boolean;
  allowColumnDelete?: boolean;
  allowColumnShift?: boolean;
  allowSearch?: boolean;
  allowFilter?: boolean;
  allowDataExport?: boolean;
  onRowUpdate?: (data) => void;
  onColumnUpdate?: (data) => void;
  onColumnShift?: (data) => void;
  onRowAdd?: (data) => void;
  onRowClick?: (rowIndex, rowData) => void;
  onColumnAdd?: (data) => void;
  onColumnDelete?: (data) => void;
  onSearch?: (searchTerm) => void;
  onFilter?: (data) => void;
  onRowSelect?: (data) => void;
  contextMenu?: boolean;
  onRowDelete?: (data, rowData) => void;
  onRowEdit?: (data) => void;
  onPagination?: (currentPage) => void;
  addButtonConfig?: AddRecordButtonConfig;
  refresh?: boolean;
  onEmployeeToAdd? : (data) => void;
  onView?: (data) => void;
  onViewContact? : (data) => void;
  moduleName? : string
  isFromSegmentList? : boolean
  onRowOpenClick?: (data) => void;
  isSelectOptionShow? : boolean;
  SelectOptionColumnsShow?:any;
  onSort?: (data)=>any;
  module?: any;
}
export interface sortInterface  {
  sortCol: string,
  sortDir: number
}
export interface IDataGridHolderState {
  tableName: string;
  columns: IColumn[];
  rows: any[];
  currentPage: number;
  totalPageCount: number;
  showContextMenu: boolean;
  needNoDataView: boolean;
  isAllRowSelected: boolean;
  width: number;
  attachmentData?:any;
  search?:string;
  showColumnVisibilityPopup?:boolean;
  sort?:sortInterface;
  hasAccess?:any;
}

class DataGridHolder extends Component<
  IDataGridHolderProps,
  IDataGridHolderState
> {
  tableId: string;
  filter: any;
  tableFilters: any[];
  selection: any[] = [];
  attachmentPickerExists: Boolean = false;
  attachmentOpenFileRef;
  sort:any;
  constructor(props) {
    super(props);
    this.tableId = TableManger.getTableId(props.tableName);
    this.filter = TableManger.getFilterObject([]);
    this.tableFilters = [];
    this.state = {
      tableName: "",
      columns: [],
      rows: [],
      currentPage: 1,
      totalPageCount: 1,
      showContextMenu: false,
      needNoDataView: false,
      isAllRowSelected: false,
      width: SideBarService.getContainerWidth(),
      attachmentData:null,
      search:"",
      showColumnVisibilityPopup:false,
      sort : {
        sortCol: '',
        sortDir: 1
      },
      hasAccess: PermissionUtils.hasAccess(this.props.module, [ACTION.EDIT])
    };
    if (!Utility.isEmpty(this.props.filter)) {
      if (Array.isArray(this.props.filter)) {
        this.filter.conditions = this.props.filter;
      } else {
        this.filter.conditions.push(this.props.filter);
      }
    };
    this.attachmentOpenFileRef = React.createRef();
    
  }
  componentWillReceiveProps(nextProps) {
    if ((this.props.filter !== nextProps.filter) || (this.props.refresh !== nextProps.refresh)) {
      if (this.props.tableName === TABLES.CANDIDATE) {
        if (Array.isArray(nextProps.filter)) {
          this.filter.conditions = nextProps.filter;
        } else {
          const index = this.filter.conditions.findIndex(
            (c) =>
              c.colId ===
                TableManger.getColumnId(
                  TABLES.CANDIDATE,
                  COLUMN_CODE.CANDIDATE.JOBOPENING
                ) ||
              c.colId ===
                TableManger.getColumnId(
                  TABLES.CANDIDATE,
                  COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
                )
          );
          if (!nextProps.isFromSegmentList) {
            if (index === -1 && !isEmpty(nextProps.filter)) {
              this.filter.conditions.push(nextProps.filter);
            } else {
              this.filter.conditions[index] = nextProps.filter;
            }
          }  else {
            if(!Array.isArray(nextProps.filter)) {
              this.filter.conditions = [{...nextProps.filter,value: [nextProps.filter.value]}]
            }
          }
        }
      }
      this.filter.conditions = this.filter.conditions.filter(c => !isEmpty(c));
      if(nextProps.isFromSegmentList && this.filter?.conditions?.length == 0){
        let segmentQuery = {
          "logicalOperator" : "and",
          "conditions":[nextProps.filter]
        }
        showLoader()
        this.applySegmentFilter("", segmentQuery)
      } else {
        this.selection = [];
        this.getRecords(this.state.search,this.filter);        
        this.setState({ 
          showContextMenu: false, 
          isAllRowSelected: false,
          hasAccess: PermissionUtils.hasAccess(nextProps.module, [ACTION.CREATE,ACTION.EDIT])
        });        
      }
      if ((nextProps.tableName === TABLES.CANDIDATE ) || !isEqual(nextProps.hiddenColumns, this.props.hiddenColumns)) {
        this.updateColumns();
      }
    }
  }
  
  componentDidMount() {
    if(!this.props.isFromSegmentList) {
      showLoader();
      this.getRecords();
    }
    window.addEventListener("resize", this.windowSizeUpdated);
    window.addEventListener('onSideBarChange', this.windowSizeUpdated);
    document.addEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    window['onDeleteAttachment'] = this.onDeleteteAttachement;
  }
  onDeleteteAttachement=(url)=> {
    const path = Utility.decodeJSON(url)
    showAlert('Delete Attachment','Are you sure you want to delete?',[
      {
          title: "Continue",
          className: "bg-app text-white mr-r",
          onClick: () => {this.deleteAttachment(path)}
      },
      {
          title: "Cancel",
          className: "bg-gray1 border-m",
          onClick: () => {},
      }
  ])
  }
  deleteAttachment(path) {
    
    let attachmentColID = path.columnKey ? path.columnKey : TableManger.getColumnId(
      this.props.tableName,
      COLUMN_CODE.CANDIDATE.DOCUMENT
    );
    const attachment = this.state.rows[path.rowIndex];
    try
    {
      let attachments = Utility.decodeJSON(attachment[path.columnKey ? path.columnKey :attachmentColID])
    
      attachments.splice(path.index,1);
      const dataToUpdate= {
        [attachmentColID]: Utility.encodeJSON(attachments)
      } 
      showLoader()
      Table.updateRecord(
        dataToUpdate,
        attachment.id,
        this.tableId
      ).then((data) => {
        
        this.getRecords(this.state.search)
      },error=>{
        removeLoader()
      });
    } catch(e) {
      console.log(e)
    }
  }
  onNewRecordAdd = (data) => {
    if (data.detail.tableName === this.props.tableName) {
      this.setState({
        sort: {
          sortCol:'',
          sortDir: 1
        }
      },this.getRecords)
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.windowSizeUpdated);
    window.removeEventListener('onSideBarChange', this.windowSizeUpdated);
    document.removeEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    if(window['onDeleteAttachment']){
      window['onDeleteAttachment'] = null;
    }
  }

  windowSizeUpdated = () => {
    this.setState({ width: SideBarService.getContainerWidth() });
    this.getColumns()
  };

  getUpdatedColumnData = (columns) => {
    if (!isViewportLarge()) {
      return columns.map((columnData) => ({
        ...columnData,
        width: Math.floor(columnData.width / 1.5),
      }));
    }

    return columns;
  };

  render() {
    return (
      <div className="column flex-1 parent-width">
        {/* {this.props.allowDataExport ? <Exporter exportHeaders={this.state.columns} exportData={this.state.rows}/> : null } */}
        {this.getDataGrid()}
        {this.state.needNoDataView && this.getNoDataView()}
      </div>
    );
  }

  applySegmentFilter = (search = "", payload): void => {
    this.selection = [];
    let req = {
      pageNo: this.state.currentPage,
      pageSize: 20,
      q: search,
    };
    if(!Utility.isEmpty(this.state.sort.sortCol)) {
      req['sortCol'] = this.state.sort.sortCol
      req['sortDir'] = this.state.sort.sortDir
    }
    Table.getRecordsByPage(req, payload, this.tableId)
      .then((res) => {
        this.updateColumns();
        this.updateRows(res);
        removeLoader();
      })
      .catch((err) => {
        removeLoader();
      });
  };
  getColumnSequense() {
    let columns = deepClone(this.state.columns)  || [];
    columns = columns.filter(column => !this.props.hiddenColumns?.includes(column.id));
    columns = columns.map(column => {
      if(column.type === 'file') {
        column.editable = false
      }
      if(this.props.tableName === TABLES.CANDIDATE) {
        switch(column.columnCode) {
          case COLUMN_CODE.CANDIDATE.JOBOPENING:
            if(!PermissionUtils.hasAccess(MODULE.JOB_OPENING,[ACTION.EDIT])) {
              column.allowAddOption = false
            }
            break;
        }
      }
      
      return column;
    })
    if(this.props.tableName == TABLES.CANDIDATE) {
      columns = [ this.getActionButtonsColumn(), ...columns]
      columns = columns.map((col) => {
        switch (col.type) {
          case INPUT_TYPE.FILE:
            col['renderer'] = this.attachmentRenderer;
            col['allowFilter'] = false;
            break;
          default:
        }
  
        col['disableWebhook'] = ![
          INPUT_TYPE.TEXT,
          INPUT_TYPE.EMAIL,
          INPUT_TYPE.NUMBER,
        ].includes(col.type);
  
        return col;
      });
    } else {
      columns = [...columns, this.getActionButtonsColumn()]
    }
    return columns;
  }
  getColumnVisibilityButton = () => ({
    title: "",
    icon: DKIcons.data_type.ic_multi_select,
    className: "bg-white text-white ml-r border-m column-filter-button",
    onClick: () => {
      this.setState({
        showColumnVisibilityPopup: true,
      });
    },
  })
  getVisibleColumns=()=>{
    let columnsToVisibleContext;
    if(this.props.tableName === TABLES.CANDIDATE) {
      columnsToVisibleContext = [
        TableManger.getColumnId(this.props.tableName,COLUMN_CODE.CANDIDATE.JOBOPENING),
        TableManger.getColumnId(this.props.tableName,COLUMN_CODE.CANDIDATE.STATUS)
      ]
    }
    return columnsToVisibleContext
  }
  getDataGrid() {
    
    const columnVisibilityButtonRect = document.getElementsByClassName('column-filter-button')?.[0]?.getBoundingClientRect();
    return (
      // <>
      <div className="column parent-height parent-width">
        {this.state.showContextMenu && (
          <ContextMenu
            tableName={this.props.tableName}
            displayTableName={this.state.tableName}
            isSelectOptionShow= {this.props.isSelectOptionShow}
            onDelete={() => this.getDeleteConfirmation(this.selection)}
            onApply={(data) => this.onContextMenuOp(data)}
            onCancel={() => this.onContextMenuCancel()}
            SelectOptionColumnsShow={this.getVisibleColumns()}
            module={this.props.module}
          />
        )}
        <DKDataGrid
          title={this.state.tableName}
          width={this.state.width}
          columns={this.getColumnSequense()}
          rows={[...this.state.rows]}
          currentPage={this.state.currentPage}
          totalPageCount={this.state.totalPageCount}
          onRowUpdate={this.onRowUpdate}
          onColumnUpdate={this.onColumnUpdate}
          onColumnShift={this.onColumnShift}
          onRowAdd={this.onRowAdd}
          onRowClick={this.onRowClick}
          onColumnAdd={this.onColumnAdd}
          onColumnDelete={this.onColumnDelete}
          onSearch={(data) => this.onSearch(data)}
          onFilter={(data) => this.onFilter(data)}
          allowRowAdd={this.props.allowRowAdd}
          allowRowEdit={this.state.hasAccess && this.props.allowRowEdit}
          allowColumnAdd={this.state.hasAccess && this.props.allowColumnAdd}
          allowColumnEdit={this.state.hasAccess && this.props.allowColumnEdit}
          isAllRowSelected={this.state.isAllRowSelected}
          allowColumnDelete={this.props.allowColumnDelete}
          allowColumnShift={this.props.allowColumnShift}
          allowSearch={this.props.allowSearch}
          allowFilter={this.props.allowFilter}
          onPrevPageTapped={() => this.onPagination(this.state.currentPage - 1)}
          onNextPageTapped={() => this.onPagination(this.state.currentPage + 1)}
          onPageChange={(page) => this.onPagination(page)}
          filterData={this.tableFilters}
          onRowSelect={(data) => this.onRowSelect(data)}
          onAllRowSelect={(data) => this.onAllRowSelect(data)}
          showHeader={!this.state.showContextMenu}
          addButton={
            (this.props.addButtonConfig && PermissionUtils.hasAccess(this.props.module,[ACTION.CREATE]) )? this.props.addButtonConfig : undefined
          }
          onSort={(data) =>this.onSort(data) }
          onRowOpenClick={(rowData,rowIndex)=> {this.props.onRowOpenClick ? this.props.onRowOpenClick(rowData): this.props.onRowEdit(rowData)} }
          contextMenu={( this.props.contextMenu)? this.getContextAction() : ''}
          buttons = {(this.props.addButtonConfig && PermissionUtils.hasAccess(this.props.module,[ACTION.CREATE])) ? Array.isArray(this.props.addButtonConfig) ? this.props.addButtonConfig : [this.props.addButtonConfig, this.getColumnVisibilityButton()] : null}
        />
        {this.state.showColumnVisibilityPopup && <ColumnVisibility
          columns={TableManger.getTableVisibleColumns(this.props.tableName)}
          style={{
            top: columnVisibilityButtonRect?.height,
            right: (columnVisibilityButtonRect?.y || 0) - ((columnVisibilityButtonRect?.width || 0) + 45),
          }}
          hiddenColumns={this.props.hiddenColumns}
          tableName={this.props.tableName}
          onCancel={() => this.setState({ showColumnVisibilityPopup: false })}
          onApply={() => {
            this.setState({ showColumnVisibilityPopup: false });
            this.getColumns();
          }}
        />}
      </div>
      // </>
    );
  }

  getNoDataView() {
    return (
        <div
            className="column align-self-center align-items-center position-absolute"
            style={{ top: "30%", pointerEvents: "none" }}
        >
            <DKIcon
                src={ic_no_data}
                className="ic-l"
                style={{ opacity: 0.2, marginTop: 70 }}
            />
            <DKLabel text="No data found" className="fw-m mt-l" />
            <DKLabel
                text="Once data is available, it will appear here"
                className="text-gray mt-s "
            />
        </div>
    );
  }
  
  getContextAction = () => {
    const editBtn ={
      title: 'Edit',
      icon: DKIcons.ic_edit,
      onClick: (data) => {
        if (this.props.onRowEdit) this.props.onRowEdit(data);
      },
    }
    const deleteBtn = {
      title:'Delete',
      icon: DKIcons.ic_delete,
      onClick: (data) => this.getDeleteConfirmation([data.rowData]),
    }
    let options = [];
    if(PermissionUtils.hasAccess(this.props.module,ACTION.EDIT)) {
      options.push(editBtn)
    }
    if(PermissionUtils.hasAccess(this.props.module,ACTION.DELETE)) {
      options.push(deleteBtn)
    }
    return options;
  }
  getActionButtonsColumn = () => {
    let options = [];
    const editBtn = {
      // icon: DKIcons.ic_edit,
      title: "Edit",
      className:'p-0 text-app fw-m text-underline',
      onClick: (data) => {
        if (this.props.onRowEdit) this.props.onRowEdit(data);
      },
    }
    if(PermissionUtils.hasAccess(this.props.module,ACTION.EDIT)) {
      options.push(editBtn)
    }
    return {
      key: "actions",
      name: "Actions",
      type: INPUT_TYPE.BUTTON,
      width: (this.props.tableName == TABLES.CANDIDATE) ? 150:100,
      options
    };
  };
   getRecords = (search = "", payload = this.filter) => {
    if(Utility.isEmpty(this.props.allHideColumnObject)) {
      this.getOrder()
    }
    if(this.props.tableName === TABLES.CANDIDATE) {
      if(payload && Array.isArray(payload.conditions)) {
        payload.conditions.forEach(con=>{
          if(typeof con.value === 'number') {
            con.value = [con.value]
          }
        })
      }
      payload = ContactManager.getFilterPayload(payload)
    }
    this.selection = [];
    let req = {
      pageNo: this.state.currentPage,
      pageSize: 20,
      q: search,
    };
    if(!Utility.isEmpty(this.state.sort.sortCol)) {
      req['sortCol'] = this.state.sort.sortCol
      req['sortDir'] = this.state.sort.sortDir
    }
    Table.getRecordsByPage(req, payload, this.tableId)
      .then((res) => {
        this.updateColumns();
        this.updateRows(res);
        if(!this.props.isFromSegmentList) {
          removeLoader();
        }
      })
      .catch((err) => {
        removeLoader();
      });
  };
  getOrder=async()=>{
    if(Utility.isEmpty(this.props.hiddenColumns?.[this.props.tableName.toUpperCase()])) {
      await this.props.getDashboardOrder();
      this.updateColumns();
    }
  }
  getColumns = () => {
    Table.getTable(TableManger.getTableId(this.props.tableName)).then(
      (data) => {
        TableManger.setTableColumns(data, this.props.tableName);
        this.updateColumns();
      },
      (err) => { }
    );
  };
  updateRows = (resp) => {
    let tableData = TableDataParser.parseRowData(resp.data, this.props.tableName);
    if (this.props.tableName && this.props.tableName === TABLES.CANDIDATE) {
      tableData = this.updateRowsForCandidate(tableData);
    }
    if (this.props.tableName && this.props.tableName === TABLES.JOB_FORMS) {
      tableData = this.updateRowsForPipeline(tableData);
    }
    if (this.props.tableName && this.props.tableName === TABLES.PEOPLE_AUTOMATION) {
      tableData = this.updateRowsForAutomation(tableData);
    }
    if (this.props.tableName && this.props.tableName === TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE) {
      tableData = this.updateRowsForEmailTemplate(tableData);
    }
    this.setState(
      {
        rows: tableData,
        totalPageCount: Math.ceil(resp.totalCount / resp.pageSize),
      },
      () => {
        this.updateColumns();
        this.setState({
          needNoDataView: this.state.rows.length === 0,
        });
      }
    );
  };

  uploadImageToAWS(imageData,attachmentColID) {
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        
        let rowData = { ...this.state.attachmentData.rowData };
        let attachment = []
        if(rowData[attachmentColID]) {
          try {
            attachment = Utility.decodeJSON(rowData[attachmentColID])
          } catch (error) {
            console.log(error);
            attachment = []
          }
        } else {
          attachment = []
        }
        let newAttachment = {
          title: imageData.name,
          type: imageData.type,
          path: url,
        };
        attachment.push(newAttachment);
        rowData[attachmentColID] = Utility.encodeJSON(attachment);
        this.onRowUpdate({
          rowIndex: this.state.attachmentData.rowIndex,
          rowData: rowData,
          columnKey: attachmentColID,
        });
        this.attachmentPickerExists = false;
      },
      (error) => {
        if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
          showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
        } else {
          showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
        }
        this.attachmentPickerExists = false;
      }
    );
  }
  getAttachmentPicker = () => {
    return (
      <input
            className="d-none"
            type="file"
            name="file"
            id={`file-input-main`}
            required
            style={{
              visibility: "hidden"
            }}
            accept={CANDIDATE_ACCEPT_FILE_TYPE.join()}
          />
    )
    
  };
  initializeImageSelect = () => {
    
  };
  checkIt = () => {
    
  };
  openAttachmentPicker = () => {
    if(!PermissionUtils.hasAccess(this.props.module, [ACTION.EDIT])) {
      this.attachmentPickerExists = true;
      this.attachmentOpenFileRef?.current?.click();
    }
    
  };
  addAttachment = (index) => {
    let data = {
      rowData: this.state.rows[index],
      rowIndex: index,
    };
    this.setState(
      {
        attachmentData: data,
      },
      () => this.openAttachmentPicker()
    );
  };

  attchFiles=() =>{
    const fileInput = document.createElement('input');
    let attachmentColID = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.DOCUMENT
    );
      fileInput.className = 'd-none';
      fileInput.type = 'file';
      fileInput.name = 'file';
      fileInput.id = `file-input-${attachmentColID}`;
      fileInput.required = true;
      fileInput.style.visibility = 'hidden';
      fileInput.accept = CANDIDATE_ACCEPT_FILE_TYPE.join()

      fileInput?.click()
      fileInput?.addEventListener('change', (e:any)=>{
        
          if (e.target.files.length > 0) {
            const fileSize = e.target.files[0].size / 1024 / 1024;
            if (fileSize > 10) {
              showAlert(
               i18next.t('FILE_SIZE_HEADER'),
               i18next.t('FILE_SIZE_ERROR')
              );
              return;
            }
            this.uploadImageToAWS(e.target.files[0],attachmentColID);
          }
      },false)
  }
  attachmentRenderer = (detail: any) => {
    let value = detail.value;
    let rowIndex = detail.rowIndex;
    
    const keys = Object.keys(detail.rowData) || []
    const columnCode = keys.find(key=>detail.rowData[key] === value)

    let attachment = [],
      jsonData = [];
      
    if (!Utility.isEmpty(value)) {
      jsonData = [];
      try{
        jsonData = Utility.decodeJSON(value);
      } catch (error) {
        console.log(error);
        jsonData = []
      }
      jsonData.forEach((data, index) => {
        data['columnKey'] = columnCode
        attachment.push(
          <div
            className="row width-auto"
          >
            <DKTooltipWrapper
              tooltipClassName="grid-file-view-popup"
              content={renderFileHtml(data,index,rowIndex)}
            >
              <DKButton
                icon={Utility.getFileIcon(data.title)}
                className="p-0"
                style={{ padding: "0px 2px", opacity: 0.8 }}
                onClick={(event) => {
                  event?.stopPropagation()
                  window.open(data.path, "_blank");
                }}
              />
            </DKTooltipWrapper>
          </div>

        );
      });
    }
    attachment.push(
      <div
        className="parent-height parent-width cursor-hand"
        onClick={() => {
          this.addAttachment(rowIndex);
        }}
      />
    );
    return (
      <div
        className="row"
        style={{ overflowX: "auto", scrollbarWidth: "thin", height: "inherit" }}
      >
        {attachment}
      </div>
    );
  };
  
  updateColumns = () => {
    let gridColumns = TableManger.getTableVisibleColumns(this.props.tableName).filter(column => !this.props.hiddenColumns?.includes(column.id));
    gridColumns = gridColumns.map((col) => {

      switch (col.type) {
        case INPUT_TYPE.FILE:
            col['renderer'] = this.attachmentRenderer;
            col['allowFilter'] = false;
            break;

        default:
    }

      col['disableWebhook'] = ![
        INPUT_TYPE.TEXT,
        INPUT_TYPE.EMAIL,
        INPUT_TYPE.NUMBER,
      ].includes(col.type);

      return col;
    });
    this.tableFilters = this.tableFilters?.filter(t=> !this.props?.hiddenColumns?.some(hc=>hc == t.key))
    this.setState({
      tableName: this.props.displayTableName
        ? this.props.displayTableName
        : "My " + TABLE_DISPLAY_NAME[this.props.tableName],
      columns: this.getUpdatedColumnData(gridColumns)
    });
    if (this.props.tableName && this.props.tableName === TABLES.CANDIDATE) {
      setTimeout(()=>{
        this.updateColumnsForCandidate();
        this.setState({
          columns: this.state.columns
        })
      },10)
    }
    if (this.props.tableName && this.props.tableName === TABLES.JOB_FORMS) {
      this.updateColumnsForJobForms();
      this.setState({
        columns: this.state.columns
      })
    }
  };
  showWarningForJobOpening =(dataToSend,isRowUpdate)=>{
    showAlert('Alert',i18next.t('JOB_OPENING_ALERT'),[
      {
          title: "Continue",
          className: "bg-app text-white mr-r",
          onClick: () => isRowUpdate ? this.onRowUpdate(dataToSend,true) : this.onContextMenuOp(dataToSend,true)
      },
      {
          title: "Cancel",
          className: "bg-gray1 border-m",
          onClick: () => this.getRecords(this.state.search),
      }
  ]);
  }
  onRowUpdate = (data,isContinue=false) => {
    let dataCopy = deepClone(data);
    let { rowData, columnKey } = data;
    let dataToUpdate = {};
    const sanitizedInput = stringSanitizer(rowData[columnKey]);
    dataToUpdate[columnKey] = sanitizedInput;
    if (this.props.tableName && this.props.tableName === TABLES.CANDIDATE) {
      let segmentColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
      let statusColumId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
      if (columnKey == segmentColumnId || columnKey == statusColumId) {
        dataToUpdate = Object.assign({}, rowData);
        let previousStages = dataToUpdate[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)] || [];
        const segmentObject = this.getSegmentAndPipelineData(dataToUpdate);
        if(segmentObject.segments && segmentObject.segments.length === 0 && !isContinue) {
          this.showWarningForJobOpening(dataCopy,true);
           removeLoader();
         return
       }
        this.getStatusAndStageData(dataToUpdate, previousStages, false);
      }
    }
    let isValidRec = true;
    if (this.props.tableName && this.props.tableName === TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE) {
      rowData = this.updateJSONForEmailTemplate(rowData);
      if(rowData && rowData['invalidFields'] && rowData['invalidFields'].length == 0){
        isValidRec = true;
      } else {
        isValidRec = false;
      }
      let statusColumId = TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS);
      if(statusColumId == columnKey) {
        dataToUpdate[columnKey] = dataToUpdate[columnKey].length == 0 ? [2]:dataToUpdate[columnKey]
      }
    }
    if(this.props.tableName && this.props.tableName !== TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE && this.checkDataInvalid(dataToUpdate, this.props.tableName, rowData)){
      if(rowData && rowData['invalidFields'] && rowData['invalidFields'].length == 0){
        isValidRec = true;
      } else {
        isValidRec = false;
      }
    }
    
    if(isValidRec) {
      Table.updateRecord(
        dataToUpdate,
        rowData.id,
        this.tableId
      ).then((data) => {
        if (this.props.onRowUpdate) this.props.onRowUpdate(data);
        this.getRecords(this.state.search)
      });
    } else {
      this.setState({
        ...this.state
      })
    }
  };
  checkDataInvalid(dataToSend, tableName, rowData) {
    let isInvalid = false;
    const tableColumns = TableManger.getTableColumns(tableName);
    const filterColumns = tableColumns.filter(col=>col.type === INPUT_TYPE.EMAIL);
    const invalidFields = [];
    filterColumns.forEach(column=>{
      if(column.id && dataToSend[column.id] && dataToSend[column.id].trim().length > VALID_FIELD_MAX_LENGTH.EMAIL) {
        isInvalid = true;
        invalidFields.push(column.id);
      }
    })
    if(!isInvalid) {
      rowData["invalidFields"] = [];
    } else {
      rowData["invalidFields"] = invalidFields;
    }
    return isInvalid
  }
  onColumnUpdate = (data) => {
    let { columnData } = deepClone(data);
    if(this.props.tableName == TABLES.CANDIDATE && COLUMN_CODE.CANDIDATE.STATUS) {
      columnData.options = columnData.options.filter(o=> typeof o.id == INPUT_TYPE.NUMBER)
    }
    Table.updateColumn(columnData, this.tableId).then((data) => {
      this.getColumns();
    });
    if (this.props.onColumnUpdate) this.props.onColumnUpdate(data);
  };
  onColumnShift = (data) => {
    let { newIndex, oldIndex } = data;
    if(this.props.tableName === TABLES.CANDIDATE) {
      newIndex = newIndex - 1;
      oldIndex = oldIndex - 1;
    }
    if(newIndex<0) {
      newIndex = oldIndex
    }
    let newColumnArray = shiftArrayElement(
      [...this.state.columns],
      oldIndex,
      newIndex
    );
    Table.shiftColumn(
      newColumnArray.map((column) => column?.key),
      this.tableId
    ).then((data) => {
      this.getColumns();
    });
    if (this.props.onColumnShift) this.props.onColumnShift(data);
  };
  onRowAdd = (data) => {
    let { rowData } = data;
    Table.addRecord({ cells: { ...rowData } }, this.tableId)
      .then((data) => {
        this.getRecords();
      })
      .catch((err) => { });
    if (this.props.onRowAdd) this.props.onRowAdd(data);
  };
  onColumnAdd = (data) => {
    let { columnData } = data;
    Table.addColumn(
      TableDataParser.getColumnToAdd(columnData),
      this.tableId
    ).then((data) => {
      this.getColumns();
    });
    if (this.props.onColumnAdd) this.props.onColumnAdd(data);
  };
  onColumnDelete = (data) => {
    let { columnData } = data;
    Table.deleteColumn(columnData.key, this.tableId).then((data) => {
      this.getColumns();
    });
    if (this.props.onColumnDelete) this.props.onColumnDelete(data);
  };
  onRowClick = (rowIndex, rowData) => {
    if(!PermissionUtils.hasAccess(this.props.module,ACTION.EDIT)) {
      return
    }
    if(rowIndex?.columnData?.type === "file") {
      const contentElement = document.getElementsByClassName("grid-file-view-popup")
      if(contentElement && contentElement.length !== 0) {
        return;
      }
      const fileInput = document.createElement('input');

      fileInput.className = 'd-none';
      fileInput.type = 'file';
      fileInput.name = 'file';
      fileInput.id = `file-input-main-${rowIndex.columnData.id}`;
      fileInput.required = true;
      fileInput.style.visibility = 'hidden';
      fileInput.accept = CANDIDATE_ACCEPT_FILE_TYPE.join()

      fileInput?.click()
      fileInput?.addEventListener('change', (e:any)=>{
        
          if (e.target.files.length > 0) {
            const fileSize = e.target.files[0].size / 1024 / 1024;
            if (fileSize > 10) {
              showAlert(
               i18next.t('FILE_SIZE_HEADER'),
               i18next.t('FILE_SIZE_ERROR')
              );
              return;
            }
            this.uploadImageToAWS(e.target.files[0],rowIndex.columnData.id);
          }
      },false)
    }
  
    if (this.props.onRowClick) this.props.onRowClick(rowIndex, rowData);
  };
  onPagination = (currentPage) => {
    this.setState({ currentPage }, this.getRecords);
    if (this.props.onPagination) this.props.onPagination(currentPage);
  };
  onSort =(data)=>{
    this.sort= 
    this.setState({sort:{
      sortDir: data.order === 'ASC' ? 1: -1,
      sortCol: data.columnData.id
    }},this.getRecords)
}
  onSearch = (data) => {
    this.setState({ currentPage: 1,search:data }, () => { debounce(this.getRecords(data),500)  });
    if (this.props.onSearch) this.props.onSearch(data);
  };
  onFilter = (data) => {
    this.filter.conditions = [];
    if (data && data.query) {
      this.tableFilters = data.query;
      if (this.tableFilters.length === 0) {
        this.filter.conditions = [];
        if (this.props.filter) {
          this.filter.conditions.push(this.props.filter);
        }
      } else {
        this.tableFilters.forEach((condition) => {
          const filterIndex = this.filter.conditions.findIndex(
            (item) => item.colId === condition.key
          );
          if (filterIndex === -1) {
            this.filter.conditions.push(
              TableManger.getFilterSubCondition(condition)
            );
          } else {
            this.filter.conditions.splice(
              filterIndex,
              1,
              TableManger.getFilterSubCondition(condition)
            );
          }
        });
      }
      this.setState({ currentPage: 1 },()=>{this.getRecords(this.state.search,this.filter)});
    }
    if (this.props.onFilter) this.props.onFilter(data);
  };
  deleteRecord = (data) => {
    Table.deleteRecordInBulk(
      data.map((item) => item.id),
      TableManger.getTableId(this.props.tableName)
    ).then((response) => {
      showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
      this.getRecords();
      this.setState({ showContextMenu: false, isAllRowSelected: false });
      if (this.props.onRowDelete) this.props.onRowDelete(response, data);
    });
  };
  onRowSelect = (data = null) => {
    if (data) {
      const index = this.selection.findIndex(
        (item) => item.id === data.rowData.id
      );
      if (index === -1) {
        this.selection.push(data.rowData);
      } else {
        this.selection.splice(index, 1);
      }
    }
    this.setState({
      showContextMenu: !(this.selection.length === 0),
      isAllRowSelected: this.selection.length === this.state.rows.length
    });
    this.props.onRowSelect && this.props.onRowSelect(this.selection);
  };
  onAllRowSelect = (data) => {
    if (!data.selected) {
      this.selection = [];
    } else {
      this.selection = [...this.state.rows];
    }
    this.setState({
      showContextMenu: !(this.selection.length === 0),
      isAllRowSelected: data.selected
    });
    this.props.onRowSelect && this.props.onRowSelect(this.selection);
  };
  onContextMenuOp = (data,isContinue=false) => {
    let dataCopy = deepClone(data)
    let isStagePresentInPipline = false;
    if (data) {
      let dataToUpdate = [];
      this.selection.forEach((row) => {
        let cells = {};
        Object.keys(data).forEach((key) => {
          cells[key] = [...data[key].map((item) => item.id)];
        });
        if (this.props.tableName && this.props.tableName === TABLES.CANDIDATE) {
          Object.keys(cells).forEach((key) => {
            row[key] = [...row[key], ...cells[key]]
          });
          let previousStages = row[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)] || [];
          const segmentObject = this.getSegmentAndPipelineData(row);
          if(segmentObject.segments && segmentObject.segments.length === 0 && !isContinue) {
            this.showWarningForJobOpening(dataCopy,true);
             removeLoader();
           return
         }
          const statusStageData = this.getStatusAndStageData(row, previousStages, true);
          if(statusStageData && !isStagePresentInPipline) {
            isStagePresentInPipline = statusStageData
          }
          cells = row;
        }
        dataToUpdate.push({
          _id: row.id,
          cells,
        });
      });
      Table.updateBulkRecord(
        dataToUpdate,
        TableManger.getTableId(this.props.tableName)
      ).then((data) => {
        if(!isStagePresentInPipline) {
          showToast("Records Updated Successfully.", TOAST_TYPE.SUCCESS);
        }        
        this.getRecords();
        this.selection = [];
        this.setState({ showContextMenu: false, isAllRowSelected: false });
      });
    }
  };
  getDeleteConfirmation = (data) => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => this.deleteRecord(data),
      },
    ];
    showAlert(
      "Delete Record?",
      "Deleting this record will delete it permanently you will not be able to restore it.",
      buttons
    );
  };
  onContextMenuCancel = () => {
    this.selection = [];
    this.setState({ showContextMenu: false, isAllRowSelected: false });
    this.getRecords();
  };
  updateColumnsForCandidate() {
    const columns = this.state.columns ? this.state.columns : [];
    if(columns && columns.length > 0) {
      const pipelineData = JobPipelineService.getPipelineData(JobPipelineService.pipelineData);
      const stageData = JobPipelineService.getStageDataWithPipelineName(JobPipelineService.stageData, pipelineData);
      const segmentColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
      const statusColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
      this.state.columns.forEach(column => {
        if(column && column.id === segmentColumnId) {
          let newOptionsSegment = column?.options?.filter(op=>typeof op.id === 'number')
          pipelineData.forEach(element => {
            const isPresent = newOptionsSegment.some(x=> x.id == element.id);
            if (!isPresent) {
              newOptionsSegment.push(element);
            }
          });
          column.options = newOptionsSegment;
          TableManger.updateColumn(COLUMN_CODE.CANDIDATE.JOBOPENING, TABLES.CANDIDATE, {
            ...TableManger.getColumn(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING),
            options: column.options,
          });
        }
        if (column && column.id === statusColumnId) {
          // const options = column.options;
          let newOptions = []
          const status = column?.options?.filter(o=>o.id == '1' || o.id == '2')||[];
          stageData.forEach(element => {

            const isPresent = newOptions.some(x => x.id === element.id);
            if (!isPresent) {
              newOptions.push(element);
            }

          });
          column.options = [...status,...newOptions];
          TableManger.updateColumn(COLUMN_CODE.CANDIDATE.STATUS, TABLES.CANDIDATE, {
            ...TableManger.getColumn(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS),
            options: column.options,
          });
        }
        if(column && ( column.columnCode === 'userId')) {
          column.hidden = true;
        }
      });
    }
  }
  updateRowsForCandidate(tableData) {
    const segmentColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
    const statusColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
    const pipelineColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
    const stageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
    if (tableData && tableData.length > 0) {
      tableData.forEach(element => {
        const assignedPipeline = element[pipelineColumnId] || [];
        const assignedStages = element[stageColumnId] || [];
        const assignedSegment = element[segmentColumnId] || [];
        const assignedStatus = element[statusColumnId] || [];
        element[segmentColumnId] = [...assignedSegment, ...assignedPipeline];
        element[statusColumnId] = [...assignedStatus, ...assignedStages];
        element["rowContextMenu"] = this.getContactAction(element)
      });
    }
    return tableData;
  }
  updateRowsForAutomation(tableData){
    if (tableData && tableData.length > 0) {
      tableData.forEach(element => {
        element["rowContextMenu"] = this.getContactAction(element)
      });
    }
    return tableData;
  }
  updateRowsForEmailTemplate(tableData) {
    let nameId = TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME);
    if (tableData && tableData.length > 0) {
      tableData.forEach(element => {
        if (!Utility.isEmpty(element[nameId].trim())) {
          element["invalidFields"] = [];
        } else {
          element["invalidFields"] = [nameId];
        }
      });
    }
    return tableData;
  }
  updateJSONForEmailTemplate(element) {
    let nameId = TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME);
    if (!Utility.isEmpty(element[nameId].trim())) {
      element["invalidFields"] = [];
    } else {
      element["invalidFields"] = [nameId];
    }
    return element;
  }

  getContactAction (element) {
    const emailColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.EMAIL);
    const employeeColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.EMPLOYEE_ID);
    let options = []

    // if(this.props.moduleName && this.props.moduleName === "Candidate"){
    //   options.push({
    //     title: 'View',
    //     icon: ic_visibility,
    //     onClick: (data) => {
    //       if (this.props.onViewContact) this.props.onViewContact(data);
    //     },
    //   },)
    // }
    if(PermissionUtils.hasAccess(this.props.module,ACTION.DELETE)) {
      options.push({
        title:'Delete',
        icon: DKIcons.ic_delete,
        onClick: (data) => this.getDeleteConfirmation([data.rowData]),
      })
    }
      


    if(
      !Utility.isEmpty(element[emailColumnId]) && 
      (Utility.isEmpty(element[employeeColumnId]) || !element[employeeColumnId]) && 
      this.props.moduleName && this.props.moduleName === "Candidate" &&
      TenantService.get(TENANT.IS_ADMIN) &&
      PermissionUtils.hasAccess(this.props.module,ACTION.EDIT)
      ){
      options.push({
        title: 'Add to Employee',
        icon: ic_add,
        onClick: (data) => {
          if (this.props.onEmployeeToAdd) this.props.onEmployeeToAdd(data);
        },
      })
    }
    if (this.props.tableName === TABLES.PEOPLE_AUTOMATION && PermissionUtils.hasAccess(MODULE.REPORTS , [ACTION.VIEW, ACTION.EXPORT])) {
        options.push({
            title: 'Workflow Report',
            icon: ic_visibility,
            onClick: (data) => {
                if (this.props.onView) {
                    data["reportType"] = "WORKFLOW";
                    this.props.onView(data);
                }
            },
        });

        if (AutomationManager.isCommissionType(element)) {
            options.push({
                title: 'Commission Report',
                icon: ic_visibility,
                onClick: (data) => {
                    if (this.props.onView) {
                        data["reportType"] = "COMMISSION";
                        this.props.onView(data);
                    }
                },
            });
        }
    }

    if (
      this.props.tableName === TABLES.CANDIDATE &&
      PermissionUtils.hasAccess(this.props.module,ACTION.EDIT)
    ) {
      options.push({
        title: i18next.t('ATTACH_FILES'),
        icon: DKIcons.ic_attachment,
        onClick: (data) => {
          this.setState(
            {
              attachmentData: data,
            },
            () => this.attchFiles()
          );
        },
        className: "p-0",
      });
    }

    return options
  }

  getSegmentAndPipelineData(data) {
    let segmentData = this.state.columns.filter(column => column.id == TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING));
    let totalSegments = segmentData.length > 0 ? segmentData[0].options : [];
    let selectedIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)];
    let assignedSegment = [];
    let assignedPipeline = [];
    let assignedStage = [];
    selectedIds.forEach(id => {
      let item = totalSegments.filter(x => x.id === id);
      if (item && item.length > 0) {
        let selection: any = item[0];
        switch (selection.type) {
          case CONSTANTS.SEGMENT:
            let isPresent = assignedSegment.some(x => selection.id === x);
            if (!isPresent) {
              assignedSegment.push(selection.id);
            }
            break;
          case CONSTANTS.PIPELINE:
            let isPresentInPipeline = assignedPipeline.some(x => selection.id === x);
            if (!isPresentInPipeline) {
              assignedPipeline.push(selection.id);
              let stageIds = selection[COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
              if (stageIds && stageIds.length > 0) {
                assignedStage.push(stageIds[0]);
              }
            }
            break;
          default:
            let isPresentinSegment = assignedSegment.some(x => selection.id === x);
            if (!isPresentinSegment && typeof selection.id === "number") {
              assignedSegment.push(selection.id);
            }
        }
      }
    });
    let jobOpeningColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
    let jobPipelineColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
    let jobStageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
    data[jobOpeningColumnId] = assignedSegment && assignedSegment.length > 0 ? assignedSegment : [1];
    data[jobPipelineColumnId] = assignedPipeline || [];
    data[jobStageColumnId] = assignedStage || [];
    return {
      segments: assignedSegment
    }
  }
  getStatusAndStageData(data, previousStages, isContextMenu) {
    let isStagePresentInPipline = false;
    let statusData = this.state.columns.filter(column => column.id == TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS));
    let totalStatus = statusData.length > 0 ? statusData[0].options : [];
    let selectedIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS)];
    selectedIds = isContextMenu ? selectedIds : selectedIds.reverse();
    let assignedStage = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)];
    let assignedStatus = [];
    let selectedUnique = selectedIds.filter(function (obj) { return previousStages.indexOf(obj) == -1; });
    selectedIds.forEach(id => {
      let item = totalStatus.filter(x => x.id === id);
      if (item && item.length > 0) {
        let selection: any = item[0];
        switch (selection.type) {
          case CONSTANTS.STATUS:
            let isPresent = assignedStatus.some(x => selection.id === x);
            if (!isPresent) {
              assignedStatus.push(selection.id);
            }
            break;
          case CONSTANTS.STAGE:
            let isPresentInStage = assignedStage.some(x => selection.id === x);
            if (!isPresentInStage) {
              let isStagePresentInPipeline = this.checkIfStageIsPresentInPipeline(data, selection.id);
              if(!isStagePresentInPipeline) {
                showAlert('Alert', 'Job pipeline is not present for selected stage.');
                if(isContextMenu && !isStagePresentInPipline) {
                  isStagePresentInPipline = true;
                }
              }
              // if (isStagePresentInPipeline) {
              //   assignedStage.push(selection.id);
              // }
            }
            break;
          default:
            let isPresentinStatus = assignedStatus.some(x => selection.id === x);
            if (!isPresentinStatus && typeof selection.id === "number") {
              assignedStatus.push(selection.id);
            }
        }
      }
    });
    let statusColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
    data[statusColumnId] = assignedStatus && assignedStatus.length > 0 ? assignedStatus : [1];
    return isStagePresentInPipline;
  }
  checkIfStageIsPresentInPipeline(data, stageId) {
    let isValidStage = false;
    let selectedPipelineIds = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID)];
    const jobPipelines = JobPipelineService.getPipelineData(JobPipelineService.pipelineData);
    selectedPipelineIds.forEach(element => {
      let selectedPipeline = jobPipelines.filter(item => item.id === element);
      if (selectedPipeline && selectedPipeline.length > 0) {
        let stages = selectedPipeline[0][COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
        let isPresent = stages.some(x => x === stageId);
        if (isPresent) {
          const jobStageColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
          let assignedStage = data[TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID)] || [];
          // let isAllowed = false;
          stages.forEach(stage => {
            if (assignedStage.some(x => x === stage)) {
              // isAllowed = true;
              let index = assignedStage.indexOf(stage);
              assignedStage.splice(index, 1, stageId);
            }
            // else {
            //   data[jobStageColumnId] = assignedStage.push(stageId);
            // }
          });
          isValidStage = true;
        }
      }
    });
    return isValidStage;
  }
  updateRowsForPipeline(tableData) {
    const segmentColumnId = TableManger.getColumnId(TABLES.JOB_FORMS, COLUMN_CODE.JOB_FORMS.SEGMENT_ID);
    const pipelineColumnId = TableManger.getColumnId(TABLES.JOB_FORMS, COLUMN_CODE.JOB_FORMS.JOB_PIPELINE_ID);
    if (tableData && tableData.length > 0) {
      tableData.forEach(element => {
        const assignedPipeline = element[pipelineColumnId] || [];
        const assignedSegment = element[segmentColumnId] || [];
        element[segmentColumnId] = [...assignedSegment, ...assignedPipeline];
      });
    }
    return tableData;
  }
  updateColumnsForJobForms() {
    const contactSegmentCol = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    let segmentData = {
      type: contactSegmentCol.type,
      options: contactSegmentCol.options,
      name: contactSegmentCol.name,
    };
    TableManger.updateColumn(COLUMN_CODE.JOB_FORMS.SEGMENT_ID, TABLES.JOB_FORMS, {
      ...TableManger.getColumn(TABLES.JOB_FORMS, COLUMN_CODE.JOB_FORMS.SEGMENT_ID),
      ...segmentData,
    });
    const columns = this.state.columns ? this.state.columns : [];
    if (columns && columns.length > 0) {
      const pipelineData = JobPipelineService.getPipelineData(JobPipelineService.pipelineData);
      const segmentColumnId = TableManger.getColumnId(TABLES.JOB_FORMS, COLUMN_CODE.JOB_FORMS.SEGMENT_ID);
      this.state.columns.forEach(column => {
        if (column && column.id === segmentColumnId) {
          pipelineData.forEach(element => {
            const isPresent = column.options.some(x => x.id === element.id);
            if (!isPresent) {
              column.options.push(element);
            }
          });
        }
      });
    }
  }
  downloadFile(data){

    let documentId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.DOCUMENT);
    let documentURL = data.rowData[documentId];
    if(documentURL && documentURL != "") {
        const link = document.createElement('a');
        link.href = documentURL;
        link.target = "_blank";
        link.rel = "noopener noreferrer"
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {

        const buttons = [
            {
              title: "Cancel",
              className: "bg-gray1 border-m",
            }
          ];
          showAlert(
            "No Resume Attached",
            "There was no resume attach for the selected contact.",
            buttons
          );
    }

  }
}
const mapStateToProps = (state, ownProps) => ({
  allHideColumnObject: state.userPref.hiddenColumn,
  hiddenColumns: state.userPref.hiddenColumns?.[ownProps.tableName.toUpperCase()] || [],
  
});
const mapDispatchToProps = {
  getDashboardOrder,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(DataGridHolder);